import React, { useEffect, useState } from "react";

const EMOTE_CATALOG = ["🔥", "🎉", "👏", "❤️", "💯", "⭐", "🙌", "🚀", "🤯", "😂"];

/**
 * Floating emote overlay. Call `add(emote)` to pop a new one. Each emote drifts up
 * for ~2.5s then fades out. Includes the emote picker strip.
 */
export function useEmoteBursts() {
  const [bursts, setBursts] = useState([]);

  const add = (emote) => {
    const id = Math.random().toString(36).slice(2);
    const left = 20 + Math.random() * 60; // percent
    setBursts((prev) => [...prev, { id, emote, left }]);
    setTimeout(() => setBursts((prev) => prev.filter((b) => b.id !== id)), 2600);
  };

  const Overlay = () => (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="emote-overlay">
      {bursts.map((b) => (
        <span
          key={b.id}
          className="absolute bottom-6 text-3xl sm:text-4xl emote-float"
          style={{ left: `${b.left}%` }}
          data-testid={`emote-burst-${b.id}`}
        >
          {b.emote}
        </span>
      ))}
      <style>{`@keyframes emoteRise{0%{transform:translateY(0);opacity:1}100%{transform:translateY(-220px);opacity:0}}.emote-float{animation:emoteRise 2.6s ease-out forwards;will-change:transform,opacity;filter:drop-shadow(0 2px 12px rgba(0,0,0,0.55));}`}</style>
    </div>
  );

  return { add, Overlay };
}

export function EmotePicker({ onPick, className = "" }) {
  return (
    <div data-testid="emote-picker" className={`flex items-center gap-1 bg-black/60 backdrop-blur rounded-full px-2 py-1 ${className}`}>
      {EMOTE_CATALOG.map((e) => (
        <button
          key={e}
          type="button"
          onClick={() => onPick(e)}
          data-testid={`emote-pick-${e}`}
          className="w-8 h-8 rounded-full hover:bg-white/10 flex items-center justify-center text-lg transition-transform hover:scale-110"
        >
          {e}
        </button>
      ))}
    </div>
  );
}

export { EMOTE_CATALOG };
